export { Templates as default } from './Templates';
